import { Route } from '@angular/router';
import { mgsIconsResolver } from '../../mgs-svg-icon.helper';
import { mgsAdminGuard } from '../../mgs-guards';
import { KUNDEN_PATH, KUNDEN_TITLE } from '../../mgs-path-defs';

export const kundeListRoute: Route = {
  path: KUNDEN_PATH,
  title: KUNDEN_TITLE,

  loadComponent: () => import('./kunde-list.component'),
  resolve: { icons: mgsIconsResolver },
  canActivate: [mgsAdminGuard]
};
